<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity end line (second line in a block)          -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row dense class="DutyActivityEnd_Default">
    <v-col v-if="hasTrueChildren" cols="2">{{ lastChildTime }}</v-col>
    <v-col v-if="hasTrueChildren" cols="10">{{ lastChildStop }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivityEnd_Default',
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    lastChildStop() {
      let lastItem = this.getLastItemSafely(this.dutyActivity.children);
      return lastItem && lastItem._endStop ? lastItem._endStop.shortname : '';
    },
    lastChildTime() {
      let lastItem = this.getLastItemSafely(this.dutyActivity.children);
      return lastItem && lastItem.toMinutesAfterMidnight ? this.time(lastItem.toMinutesAfterMidnight) : '';
    },
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
    getLastItemSafely(arr) {
      if (arr && arr.length > 0) {
        return arr[arr.length - 1];
      }
      return null;
    },
  },
};
</script>
